<template>
  <div class="addMoreCollection">
    <div class="addMoreCollection__header">
      <div class="addMoreCollection__header__left">
        <div class="addMoreCollection__header__left__top" @click="backToCollectionEditor">
          <div class="addMoreCollection__header__left__top__back">
            <img src="/img/icons/ic-arrow-left.svg" alt="">
            <!-- <i class="icon-arrow-back"></i> -->
            <p>Back to collection editor</p>
          </div>
        </div>
        <div class="addMoreCollection__header__left__title">
          <h1 class="medium-title">Add Listing</h1>
        </div>
      </div>
    </div>
    <div class="addMoreCollection__filter">
      <div class="addMoreCollection__filter__left">
        <template v-if="selectedQuickValue == 'LS' || selectedTypeValue">
          <adx-dropdown-search labelButton="Locations" :list="locations" @selected="selectedLocation" :selected-value="selectedLocationValue"/>
          <adx-dropdown-checkbox v-if="brands.length > 0" labelButton="Brands" :list="brands" :title="`Brands`" :default="selectedBrandValue" @selected="selectedBrand"/>
          <adx-dropdown-checkbox v-if="social.length > 0" labelButton="Social" :list="social" :title="`Social`" :default="selectedSocialValue" @selected="selectedSocial"/>
          <adx-dropdown-checkbox v-if="profile.length > 0" labelButton="Profile" :list="profile" :title="'Profile'" :default="selectedProfileValue" @selected="selectedProfile"/>
        </template>
        <template v-else-if="selectedQuickValue == 'ML'">
          <adx-dropdown-checkbox v-if="brands.length > 0" labelButton="Brands" :list="brands" :title="`Brands`" :default="selectedBrandValue" @selected="selectedBrand"/>
        </template>
        <template v-else-if="selectedQuickValue == 'BU'">
          <adx-dropdown-checkbox v-if="surroundings.length > 0" labelButton="Surrounding" :list="surroundings" :title="`Surrounding`" :default="selectedSurroundingValue" @selected="selectedSurrounding"/>
        </template>
        <template v-else-if="selectedQuickValue == 'AR'">
          <adx-dropdown-search labelButton="Locations" :list="locations" @selected="selectedLocation" :selected-value="selectedLocationValue"/>
          <adx-dropdown-checkbox v-if="brands.length > 0" labelButton="Brands" :list="brands" :title="`Brands`" :default="selectedBrandValue" @selected="selectedBrand"/>
        </template>
        <adx-dropdown-list class="addMoreCollection__filter__left__sort--mobile" labelButton="Sort by" :list="sort" :title="'Sort by'" @selected="selectedSort"/>
        <div class="addMoreCollection__filter__left__sort--mobile">
          <button class="btn-regular" @click="showQuickFilter = true" :class="[labelType == 'Type' ? 'secondary' : 'teal']">{{labelType}}</button>
        </div>
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="addMoreCollection__filter__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sort"/>
        </div>
      </div>
    </div>
    <div class="addMoreCollection__content">
      <div class="addMoreCollection__content__left">
        <div class="addMoreCollection__content__left__header">
          <div class="addMoreCollection__content__left__header__breadcrumb">
            <adx-breadcrumb :items="breadcrumb"/>
          </div>
          <div class="addMoreCollection__content__left__header__search">
            <div class="addMoreCollection__content__left__header__search__input">
              <i class="adx-ic_search"></i>
              <input type="text" class="subhead" placeholder="Search" v-model="searchBoxValue">
            </div>
          </div>
        </div>
        <div v-if="searchError" class="addMoreCollection__content__left__header__error">
          <div class="addMoreCollection__content__left__header__error__top">
            <span>We didn't find any match for : </span>
            <span class="search">"{{searchBoxValue}}"</span>
          </div>
          <div class="addMoreCollection__content__left__header__error__bottom">
            <span>Maybe you want to check other listing : </span>
          </div>
        </div>
        <div class="addMoreCollection__content__left__listing">
          <adx-item-list :items="items" :loading="isLoading" :channel="selectedQuickName" :headers="headers" :page="count" @reloadData="initalLoad" @loadMore="loadData">
          <!-- <adx-infinite-loading slot="infiniteLoading" @infinite="loadData($event)" :isFirstLoad="false" :distance="1" ref="InfiniteLoadingRefs">
              <span slot="no-more">
              </span>
              <span slot="no-results">
              </span>
              <span slot="spinner">
              </span>
          </adx-infinite-loading> -->
            <template slot="loading" v-if="items.length > 0">
              <template v-if="!isLoading">
                <div v-if="next" class="addMoreCollection__content__left__listing__paging" @click.stop="loadData">
                  <span class="addMoreCollection__content__left__listing__paging__load">Show more</span>
                </div>
                <div v-else class="addMoreCollection__content__left__listing__paging">
                  <span class="addMoreCollection__content__left__listing__paging__empty"> There is no more data </span>
                </div>
              </template>
              <template v-else>
                <adx-loading slot="loading" />
              </template>
            </template>
          </adx-item-list>
        </div>
      </div>
      <div class="addMoreCollection__content__right">
        <adx-quick-filter :list="quickFilter" :value.sync="selectedQuickValue" @selectSub="selectSub"/>
      </div>
    </div>
    <adx-modal v-if="showQuickFilter" title="Type" @modal-close="showQuickFilter = false">
      <div slot="content" class="content">
        <div class="addMoreCollection__type">
          <ul>
            <li v-for="(item, index) in quickFilter" :key="index">
              <div class="addMoreCollection__type__content" @click="selectType(item, index)">
                {{item.label.charAt(0).toUpperCase() + item.label.substr(1)}}
                <i v-if="item.subitem" :class="isTypeExpand.includes(index) ? 'icon-chevronup' : 'icon-chevrondown'"></i>
              </div>
              <div v-if="isTypeExpand.includes(index)" class="addMoreCollection__type--child">
                <ul>
                  <li v-for="(child, childin) in item.subitem" :key="childin" @click="selectSubType(child, item)">{{child.label}}</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListAddMore from '@/views/Collection/AddMore/ListAddmore'
import QuickFilter from '@/components/QuickFilter'
import Loading from '@/components/Loading/Primary'
import BreadCrumb from '@/components/Breadcrumb'
import Modal from '@/components/Modal'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { deviceParams } from '@/api/params'
import { fromKeys } from '@/lib/transformer'
import types from '@/lib/types'
import InfiniteLoading from 'vue-infinite-loading'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-addmore-collectioneditor',
  components: {
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-sort': DropdownSort,
    'adx-item-list': ListAddMore,
    'adx-quick-filter': QuickFilter,
    'adx-breadcrumb': BreadCrumb,
    'adx-infinite-loading': InfiniteLoading,
    'adx-loading': Loading,
    'adx-modal': Modal,
  },
  data () {
    return {
      count: 0,
      next: '',
      LocationList: [],
      BrandList: [],
      SortList: [],
      items: [],
      isLoading: false,
      isInit: true,
      selectedQuickValue: `LS`,
      sort: types.deviceOrdering,
      selectedSortValue: types.deviceOrdering[3].value,
      locations: [],
      selectedLocationValue: '',
      brands: [],
      selectedBrandValue: [],
      social: [],
      selectedSocialValue: [],
      profile: [],
      selectedProfileValue: [],
      surroundings: [],
      selectedSurroundingValue: [],
      selectedTypeValue: '',
      selectedTypeName: '',
      selectedQuickName: 'Lifestyle',
      searchBoxValue: '',
      quickFilter: [],
      searchError: false,
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      labelType: 'Lifestyle',
      showQuickFilter: false,
      isTypeExpand: [],
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      let querys = this.$route.query
      Object.keys(querys).forEach(function(key) {
        if (key !== 'sort_by' && key !== 'category' &&
        key !== 'property_type' && key !== 'search' &&
        querys[key]) filtered = true
      });

      // if (
      //   this.selectedTypeValue ||
      //   this.selectedProfileValue.length ||
      //   this.selectedBrandValue.length ||
      //   this.selectedSocialValue.length ||
      //   this.selectedLocationValue
      // ) filtered = true

      return filtered
    },
    getFilterParams: function () {
      let params = {
        property_type: this.selectedTypeValue || undefined,
        sort_by: this.selectedSortValue || undefined,
        profile: this.selectedProfileValue.join(`,`) || undefined,
        brand: this.selectedBrandValue.join(`,`) || undefined,
        social: this.selectedSocialValue.join(`,`) || undefined,
        location: this.selectedLocationValue || undefined,
        search: this.searchBoxValue || undefined,
        category: this.selectedQuickValue || undefined,
        surrounding: this.selectedSurroundingValue.join(`,`) || undefined,
      }
      this.$router.replace({
        query: params
      })
      return params
    },
    breadcrumb () {
      const params = [
        {
          title: this.selectedQuickName
        },
        {
          title: this.selectedTypeName
        },
      ]
      return params
    },
  },
  watch: {
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.initalLoad()
      });
    },
    selectedQuickValue: function(newValue, oldValue) {
      const QuickName = this.quickFilter.filter(data => {
        return data.value == newValue
      })
      if (newValue) {
        this.selectedQuickName = QuickName.pop().label
        this.labelType = this.selectedQuickName.charAt(0).toUpperCase() + this.selectedQuickName.substr(1)
        this.selectedTypeValue = undefined
        this.selectedTypeName = undefined
        this.searchBoxValue = ''
        this.$nextTick(() => {
          this.initalLoad()
        });
      }
    },
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.initalLoad()
      });
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.getQuickFilter()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initalLoad(isInit = null) {
      (async () => {
        this.$data.isLoading = true
        this.searchError = false
        const categoryName = this.$options.name.split('-').pop()
        const collectionId = this.$route.params.id
        let params = {
          ...deviceParams[categoryName],
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.addMoreCollection(collectionId), { needToken: true, params: params })
        if (!data.count && this.searchBoxValue) {
          this.searchError = true
        } else {
          this.count = data.count
          this.items = data.results
          this.page = 2
          this.next = data.next
        }

        this.$data.isLoading = false
      })();
    },
    resetPageState() {
      this.$data.items = []
      this.$data.count = null
      this.$data.page = 1
      this.$data.next = null
      // this.$refs.InfiniteLoadingRefs.stateChanger.reset()
    },
    selectedLocation(item) {
      this.selectedLocationValue = item.id.toString()
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedBrand(item) {
      this.selectedBrandValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSocial(item) {
      this.selectedSocialValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedProfile(item) {
      this.selectedProfileValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      })
    },
    selectedSurrounding(item){
      this.selectedSurroundingValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSort(item){
      if (this.selectedSortValue === item.value){
        this.selectedSortValue = 'name'
      } else {
        this.selectedSortValue = item.value
      }
    },
    selectedType(item){
      this.selectedTypeValue = item.value
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    getQuickFilter () {
      (async () => {
        const { data } = await api.get(apiV2.devicesFilters)
        const params = data.map( category => {
          if(category.child){
            const subitem = category.child.map(child => {
              return {
                label: child.name,
                value: child.value
              }
            })
            return {
              label: category.name,
              value: category.value,
              subitem: subitem
            }
          }
          return {
            label: category.name,
            value: category.value
          }
        })
        this.quickFilter = params
        this.quickFilter.sort((a, b) => { 
          let orderingRule = ['LS', 'BU', 'ML', 'AR']
          return orderingRule.indexOf(a.value) - orderingRule.indexOf(b.value)
         })
        this.getFilter()
        this.initialRouteQuery()
      })();
    },
    getFilter() {
      (async () => {
        const categoryName = this.selectedQuickValue
        const { data } = await api.get(apiV2.deviceFilters, {
          params: deviceParams[categoryName]
        })
        this.mapFilter(data)
      })();
    },
    mapFilter(data) {
      const brands = data.brands.map(brand => {
        return {
          id: brand.id,
          label: brand.title,
          value: brand.id
        }
      })
      const social = data.social.map(social => {
        return {
          id: social.id,
          label: social.title,
          value: social.id
        }
      })
      const profile = data.profile.map(profile => {
        return {
          id: profile.id,
          label: profile.id,
          value: profile.id
        }
      })
      this.locations = data.cities
      this.brands = brands
      this.social = social
      this.surroundings = fromKeys(data.surrounding)
      this.profile = profile
    },
    initialRouteQuery() {
      Object.keys(this.$route.query).map(key => {
        if (this.$route.query[key]) {
          if (key == 'sort_by') this.selectedSortValue = this.$route.query[key]
          if (key == 'profile') this.selectedProfileValue = this.$route.query[key].split(',')
          if (key == 'brand') this.selectedBrandValue = this.$route.query[key].split(',')
          if (key == 'social') this.selectedSocialValue = this.$route.query[key].split(',')
          if (key == 'location') this.selectedLocationValue = this.$route.query[key]
          if (key == 'surrounding') this.selectedSurroundingValue = this.$route.query[key].split(',')
          if (key == 'category') this.selectedQuickValue = this.$route.query[key]

          if (key == 'property_type') {
            this.selectedTypeValue = this.$route.query[key]
            this.quickFilter.map(data => {
              if (data.subitem) {
                data.subitem.map(child => {
                  if (child.value == this.selectedTypeValue) {
                    this.labelType = child.label
                    this.selectedTypeName = child.label
                    this.selectedQuickValue = undefined
                    this.selectedQuickName = data.label
                  }
                })
              }
            })
          }
        }
      })
      this.initalLoad();
    },
    selectSub(item, parent) {
      this.searchBoxValue = ''
      this.selectedTypeValue = item.value
      this.selectedTypeName = item.label
      this.selectedQuickValue = undefined
      this.selectedQuickName = parent.label
      this.initalLoad()
    },
    selectType(item, index){
      if (item.subitem) {
        const include = this.isTypeExpand.includes(index)
        this.isTypeExpand = []
        if (!include) this.isTypeExpand.push(index)
      } else {
        this.showQuickFilter = false
      }
      this.selectedQuickValue = item.value
    },
    selectSubType(item, parent) {
      this.labelType = item.label.charAt(0).toUpperCase() + item.label.substr(1)
      this.showQuickFilter = false
      this.selectSub(item, parent)
    },
    async loadData($state) {
      if (this.next) {
        this.isLoading = true
        const collectionId = this.$route.params.id
        let params = {
          page: this.page,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.addMoreCollection(collectionId), { needToken: true, params: params })
        if (data.results) {
          // this.items = this.items.concat(data.results)
          // this.next = data.next
          // $state.loaded();
          // if (!data.next) {
          //   $state.complete()
          // }
          this.$data.items = this.$data.items.concat(data.results)
          this.$data.count = data.count
          this.$data.next = data.next
        } else {
          // $state.complete()
        }
        this.page += 1
        this.isLoading = false
      }
    },
    backToCollectionEditor() {
      this.$router.push({name: 'collectioneditor', params: { id: this.$route.params.id }})
    },
    resetFilter() {
      this.selectedSurroundingValue = []
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedLocationValue = ''

      const params = {
        surrounding: undefined,
        profile: undefined,
        brand: undefined,
        social: undefined,
        location: undefined
      }
      this.$router.replace({
        query: params
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>